import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/layout/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import ProductFormPage from './pages/ProductFormPage';
import ProductDetailPage from './pages/ProductDetailPage';
import InventoryPage from './pages/InventoryPage';
import ClientsPage from './pages/ClientsPage';
import ClientFormPage from './pages/ClientFormPage';
import ClientDetailPage from './pages/ClientDetailPage';
import SalesPage from './pages/SalesPage';
import SaleDetailPage from './pages/SaleDetailPage';
import InvoicesPage from './pages/InvoicesPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import PurchasesPage from './pages/PurchasesPage';
import PurchaseFormPage from './pages/PurchaseFormPage';
import PurchaseDetailPage from './pages/PurchaseDetailPage';
import SuppliersPage from './pages/SuppliersPage';
import SupplierDetailPage from './pages/SupplierDetailPage';
import CashPage from './pages/CashPage';
import CashDetailPage from './pages/CashDetailPage';
import QuotesPage from './pages/QuotesPage';
import QuoteDetailPage from './pages/QuoteDetailPage';
import GuidesPage from './pages/GuidesPage';
import GuideDetailPage from './pages/GuideDetailPage';
import UsersPage from './pages/UsersPage';
import CompanyPage from './pages/CompanyPage';
import ReportsPage from './pages/ReportsPage';
import SuperadminPlansPage from './pages/SuperadminPlansPage';
import MyPlanPage from './pages/MyPlanPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="productos" element={<ProductsPage />} />
            <Route path="productos/nuevo" element={<ProductFormPage />} />
            <Route path="productos/:uid" element={<ProductDetailPage />} />
            <Route path="productos/:uid/editar" element={<ProductFormPage />} />
            <Route path="inventario" element={<InventoryPage />} />
            <Route path="mi-plan" element={<MyPlanPage />} />
            <Route path="ventas" element={<SalesPage />} />
            <Route path="ventas/:id" element={<SaleDetailPage />} />
            <Route path="comprobantes" element={<InvoicesPage />} />
            <Route path="comprobantes/:type/:id" element={<InvoiceDetailPage />} />
            <Route path="compras" element={<PurchasesPage />} />
            <Route path="compras/nueva" element={<PurchaseFormPage />} />
            <Route path="compras/:id" element={<PurchaseDetailPage />} />
            <Route path="compras/:id/editar" element={<PurchaseFormPage />} />
            <Route path="clientes" element={<ClientsPage />} />
            <Route path="clientes/nuevo" element={<ClientFormPage />} />
            <Route path="clientes/:id" element={<ClientDetailPage />} />
            <Route path="clientes/:id/editar" element={<ClientFormPage />} />
            <Route path="proveedores" element={<SuppliersPage />} />
            <Route path="proveedores/:ruc" element={<SupplierDetailPage />} />
            <Route path="caja" element={<CashPage />} />
            <Route path="caja/:id" element={<CashDetailPage />} />
            <Route path="cotizaciones" element={<QuotesPage />} />
            <Route path="cotizaciones/:id" element={<QuoteDetailPage />} />
            <Route path="guias" element={<GuidesPage />} />
            <Route path="guias/:id" element={<GuideDetailPage />} />
            <Route path="usuarios" element={<UsersPage />} />
            <Route path="reportes" element={<ReportsPage />} />
            <Route path="configuracion" element={<CompanyPage />} />
            <Route path="superadmin/planes" element={<SuperadminPlansPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
